import React, { useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import moment from "moment";

const ActivityCrypto = ({ handelClose, updateCrypto, loading, setLoading }) => {
  const [pageData, setPageData] = useState([]);
  console.log({ updateCrypto });

  return (
    <Index.Box className="table-box table_scroll">
      <Index.Box className="episap-modal-box second-episap-modal-box">
        <Index.Box className="episap-modal-header">
          <Index.Box className="edit-modal-circle-main">
            <Index.Box className="title-header">
              <Index.Box className="title-header-flex res-title-header-flex category-modal-header">
                <Index.Box className="title-main">
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="page-title"
                  >
                    Buy With Crypto Setup Activity
                  </Index.Typography>
                  {/* <Index.Typography variant="p" component='p' className='page-sub-title'>
                            Please fill the input blow here
                        </Index.Typography> */}
                </Index.Box>
              </Index.Box>
            </Index.Box>
            <Index.Box className="user-circle-img" onClick={handelClose}>
              <img
                src={PagesIndex.Svg.whiteclose}
                className="user-circle-img"
                alt="icon"
              />
            </Index.Box>
          </Index.Box>
        </Index.Box>
        <Index.Box className="admin-design-div login-input-design-div">
          <Index.Box className="table-box table_scroll">
            <Index.TableContainer
              component={Index.Paper}
              className="episap-table-container activity-table-container"
            >
              <Index.Table
                stickyHeader
                aria-label="sticky table"
                className="episap-table-main user-list-table"
              >
                <Index.TableHead className="table-head">
                  <Index.TableRow>
                    <Index.TableCell align="left">No </Index.TableCell>
                    <Index.TableCell align="left">Description</Index.TableCell>
                    <Index.TableCell align="left">Updated By</Index.TableCell>
                    <Index.TableCell align="center">
                      Updated Date and Time
                    </Index.TableCell>
                  </Index.TableRow>
                </Index.TableHead>
                <Index.TableBody className="table-body">
                  {!loading ? (
                    pageData?.length ? (
                      pageData.map((row, index) => {
                        return (
                          <Index.TableRow key={row?.sNo}>
                            <Index.TableCell align="left">
                              {index + 1}
                            </Index.TableCell>

                            <Index.TableCell
                              align="left"
                              className="table-title-word-break"
                            >
                              {row?.updatedEntry &&
                                row?.updatedEntry?.map((entry, index) => (
                                  <div key={index}>
                                  {`- ${entry?.field} updated `}
                                  <span>{entry?.previousValue}</span>
                                  {` to `}
                                  <span>{entry?.currentValue}</span>
                                  {` by ${row?.updatedBy?.fullName}.`}
                                </div>
                                
                                ))}
                            </Index.TableCell>

                            <Index.TableCell align="left" sx={{ width: "14%" }}>
                              {row?.updatedBy?.fullName}
                            </Index.TableCell>

                            <Index.TableCell
                              align="center"
                              sx={{ width: "24%" }}
                            >
                              {moment(row?.updatedAt).format(
                                "DD/MM/YYYY hh:mm A"
                              ) || "-"}
                            </Index.TableCell>
                          </Index.TableRow>
                        );
                      })
                    ) : (
                      <PagesIndex.NoRecordFound colSpan={12} />
                    )
                  ) : (
                    <PagesIndex.PageLoading colSpan={12} />
                  )}
                </Index.TableBody>
              </Index.Table>
            </Index.TableContainer>
          </Index.Box>
          <Index.Box className="pagination-design flex-end">
            <Index.Stack spacing={2}>
              <PagesIndex.Pagination
                fetchData={updateCrypto || []}
                setPageData={setPageData}
                pageData={pageData}
              />
            </Index.Stack>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </Index.Box>
  );
};

export default ActivityCrypto;
